// src/pages/customers/CustomerAddresses/CustomerAddressDetailPage.jsx
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { CustomerAddressesAPI } from '../../../api/v3/customers-api-v3';
import AddressCard from '../../../components/customers/AddressCard';

const BASE = '/app/sales/bagspa';

export default function CustomerAddressDetailPage() {
  const { customerId, id } = useParams();
  const [address, setAddress] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const a = await CustomerAddressesAPI.show(customerId, id);
        setAddress(a?.item || a?.data || a || null);
      } catch (e) { setError(e.message); }
    })();
  }, [customerId, id]);

  if (!address) return <div>Loading…</div>;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">Address #{address.id}</h2>
        <div>
          <Link className="btn btn-light mr-2" to={`${BASE}/customers/${customerId}`}>Back to Customer</Link>
          <Link className="btn btn-primary" to={`${BASE}/customers/${customerId}/addresses/${id}/edit`}>Edit</Link>
        </div>
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
      <AddressCard address={address} />
    </div>
  );
}
